export default __webpack_public_path__ + "static/media/home.71777fcf.jpg";